import { requests } from 'api';
import { ContactState } from './types';

const apiBaseUrl = '/api/contactstates';

export const ContactStatesApi = {
  getAll: (): Promise<ContactState[]> => requests.get(apiBaseUrl),
};
